import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const Authmiddleware = (props) => {
  const location = useLocation();
  const token = localStorage.getItem("accessToken");

  // Get role from Redux
  const { user, role } = useSelector((state) => state.Login);

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If no user or role in Redux, try to parse from localStorage as fallback
  let userRole = role;
  let fallbackUser = null;

  if (!user || !role) {
    const userStr = localStorage.getItem("user");
    try {
      fallbackUser = userStr ? JSON.parse(userStr) : null;
      if (fallbackUser?.is_admin === "1" || fallbackUser?.is_admin === true) {
        userRole = "admin";
      } else if (
        fallbackUser?.is_resturant === true ||
        fallbackUser?.is_resturant === "1" ||
        fallbackUser?.is_restaurant === true ||
        fallbackUser?.is_restaurant === "1"
      ) {
        userRole = "restaurant";
      } else {
        userRole = "customer";
      }
    } catch (e) {
      console.error("Failed to parse user data:", e);
      localStorage.removeItem("accessToken");
      localStorage.removeItem("user");
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
  }

  // Role-based route protection
  const path = location.pathname;

  // If customer tries to access restaurant/admin routes, redirect to login or their dashboard
  if (userRole === "customer") {
    // Check for /restaurant/* (restaurant portal routes) but allow /restaurants (customer restaurants page)
    if (
      (path.startsWith("/restaurant") && path !== "/restaurants") ||
      path.startsWith("/admin")
    ) {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
  }

  // If restaurant user tries to access admin routes, redirect to login or restaurant dashboard
  if (userRole === "restaurant") {
    if (path.startsWith("/admin")) {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
    // If restaurant user is on customer routes (except /restaurants), redirect to restaurant dashboard
    if (
      !path.startsWith("/restaurant") &&
      path !== "/" &&
      path !== "/restaurants"
    ) {
      return <Navigate to="/restaurant/dashboard" replace />;
    }
  }

  // If admin tries to access restaurant routes, redirect to login or admin dashboard
  if (userRole === "admin") {
    if (path.startsWith("/restaurant")) {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
    // If admin is on customer routes, redirect to admin dashboard
    if (!path.startsWith("/admin") && path !== "/") {
      return <Navigate to="/admin/dashboard" replace />;
    }
  }

  return <React.Fragment>{props.children}</React.Fragment>;
};

export default Authmiddleware;
